import React, { useEffect } from "react";
import Header from "../Templete/Header";
import Footer from "../Templete/Footer";

const TermsAndConditions = () => {
  useEffect(() => {
    document.title = "Terms & Conditions | FORMAX MONEY";
  }, []);

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Terms & Conditions</h1>
          <p>
            Please read these terms carefully before using our services. This
            document forms a legally binding agreement between you and FORMAX
            MONEY.
          </p>
        </div>
      </section>

      <div className="container">
        <div className="privacy-content">
          <div className="privacy-card">
            <h2>1. Introduction & Acceptance of Terms</h2>
            <p>
              Welcome to FORMAX MONEY. These Terms & Conditions ("Terms") govern
              your access to and use of the website{" "}
              <strong>formaxmoney.in</strong>, mobile application (if
              applicable), and all services provided by
              <strong> FORMAX IT SOLUTIONS PRIVATE LIMITED</strong> ("Company",
              "we", "us", "our"). By accessing or using our platform, you agree
              to be bound by these Terms. If you do not agree, please do not use
              our services.
            </p>
            <p>
              These Terms are governed by the laws of India, including the
              Information Technology Act, 2000, and applicable RBI guidelines
              for Business Correspondents.
            </p>
          </div>

          <div className="privacy-card">
            <h2>2. Eligibility</h2>
            <p>
              You must be at least <strong>18 years of age</strong> to use our
              services. By using FORMAX MONEY, you represent and warrant that
              you are legally competent to enter into a binding contract under
              Indian law. For BC Agents, additional KYC and verification
              requirements as per bank guidelines must be fulfilled.
            </p>
          </div>

          <div className="privacy-card">
            <h2>3. Services Provided</h2>
            <p>
              FORMAX MONEY, as a bank-licensed Corporate Business Correspondent,
              offers financial inclusion services including, but not limited to:
            </p>
            <ul>
              <li>AEPS (Aadhaar Enabled Payment System)</li>
              <li>Domestic Money Transfer (DMT)</li>
              <li>Cash Management Services (CMS)</li>
              <li>UPI Cash Point</li>
              <li>Micro ATM Services</li>
              <li>BC Agent Onboarding & Support</li>
            </ul>
            <p>
              All services are provided on an "as is" and "as available" basis.
              We reserve the right to modify, suspend, or discontinue any
              service at any time without prior notice. We are not liable for
              any loss or inconvenience caused by such changes.
            </p>
          </div>

          <div className="privacy-card">
            <h2>4. BC Agent Registration & Account</h2>
            <p>
              To become a BC Agent, you must complete the registration process
              and fulfill KYC requirements including:
            </p>
            <ul>
              <li>Submission of valid PAN Card and Aadhaar Card</li>
              <li>Bank account details for commission settlements</li>
              <li>Physical verification of agent premises</li>
              <li>Shop verification as per bank guidelines</li>
            </ul>
            <p>
              You agree to maintain the confidentiality of your login
              credentials and notify us immediately of any unauthorized use of
              your account. We reserve the right to suspend or terminate
              accounts that violate these Terms or fail to meet compliance
              requirements.
            </p>
          </div>

          <div className="privacy-card">
            <h2>5. User & BC Agent Responsibilities</h2>
            <p>As a user or BC Agent of FORMAX MONEY, you agree to:</p>
            <ul>
              <li>
                Verify all transaction details (amount, beneficiary, service
                type) before confirming any transaction.
              </li>
              <li>
                Ensure compliance with all applicable RBI guidelines and banking
                regulations.
              </li>
              <li>
                Maintain proper records of all transactions as per regulatory
                requirements.
              </li>
              <li>
                Not use our services for any illegal, fraudulent, or speculative
                purposes.
              </li>
              <li>
                Provide accurate information and genuine customer details for
                all transactions.
              </li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>6. Prohibited Activities</h2>
            <p>You are strictly prohibited from:</p>
            <ul>
              <li>
                Using our services for any illegal, fraudulent, or unauthorized
                purpose including money laundering.
              </li>
              <li>
                Attempting to bypass or disable any security features of the
                platform.
              </li>
              <li>
                Interfering with or disrupting the integrity or performance of
                our services.
              </li>
              <li>
                Reverse engineering, decompiling, or extracting the source code
                of our platform.
              </li>
              <li>
                Using automated scripts, bots, or crawlers without explicit
                permission.
              </li>
              <li>Uploading malicious code, viruses, or harmful software.</li>
              <li>
                Engaging in any activity that could damage, disable, or impair
                our servers.
              </li>
              <li>
                Conducting transactions without proper customer authorization.
              </li>
            </ul>
            <p>
              Violation of these prohibitions may result in immediate
              termination of your account and legal action including reporting
              to regulatory authorities.
            </p>
          </div>

          <div className="privacy-card">
            <h2>7. Transactions & Settlement Policy</h2>
            <p>
              All transactions are processed through bank-integrated platforms.
              By using our services, you agree to:
            </p>
            <ul>
              <li>
                <strong>No Refunds for Successful Transactions:</strong> Once a
                transaction is successfully completed, no refund will be issued.
              </li>
              <li>
                <strong>Auto-Refund for Failed Transactions:</strong> If a
                transaction fails due to technical reasons, the amount is
                automatically refunded within 5–7 business days.
              </li>
              <li>
                <strong>Commission Settlements:</strong> BC Agent commissions
                are settled as per the agreed payout schedule.
              </li>
              <li>
                <strong>Transaction Reversal:</strong> In case of any dispute,
                transaction reversal will be subject to bank investigation and
                approval.
              </li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>8. Third-Party Services & Partners</h2>
            <p>
              Our platform integrates with third‑party service providers (banks,
              NPCI, payment gateways, etc.). We are not responsible for their
              actions, errors, delays, or service failures. Any disputes
              regarding service delivery after successful transaction must be
              raised with the respective bank or service provider. We act as a
              facilitator and cannot guarantee resolution.
            </p>
            <p>
              We partner with leading banks and financial institutions including
              SBI, HDFC Bank, ICICI Bank, Axis Bank, and NPCI. Service
              availability may vary based on partner uptime.
            </p>
          </div>

          <div className="privacy-card">
            <h2>9. Intellectual Property</h2>
            <p>
              All content on our platform, including text, graphics, logos,
              icons, images, software, and code, is the property of FORMAX IT
              SOLUTIONS PRIVATE LIMITED or its licensors and is protected by
              Indian copyright, trademark, and other intellectual property laws.
              You may not reproduce, distribute, modify, or create derivative
              works without our prior written consent.
            </p>
          </div>

          <div className="privacy-card">
            <h2>10. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, FORMAX IT SOLUTIONS
              PRIVATE LIMITED and its directors, employees, or affiliates shall
              not be liable for any indirect, incidental, special,
              consequential, or punitive damages, including loss of profits,
              data, or goodwill, arising from:
            </p>
            <ul>
              <li>Your use or inability to use our services.</li>
              <li>Any errors, omissions, or interruptions in service.</li>
              <li>Unauthorized access to or alteration of your data.</li>
              <li>Any conduct or content of third parties on our platform.</li>
              <li>Bank downtime or technical failures at partner banks.</li>
            </ul>
            <p>
              Our total liability to you for any claim arising out of these
              Terms shall not exceed the amount you paid for the specific
              transaction giving rise to the claim.
            </p>
          </div>

          <div className="privacy-card">
            <h2>11. Disclaimer of Warranties</h2>
            <p>
              Our services are provided on an "as is" and "as available" basis
              without any warranties of any kind, either express or implied. We
              do not warrant that:
            </p>
            <ul>
              <li>
                The services will be uninterrupted, timely, secure, or
                error-free.
              </li>
              <li>
                The results obtained from using the services will be accurate or
                reliable.
              </li>
              <li>Any errors in the platform will be corrected.</li>
              <li>Partner bank services will always be available.</li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>12. Indemnification</h2>
            <p>
              You agree to indemnify, defend, and hold harmless FORMAX IT
              SOLUTIONS PRIVATE LIMITED, its directors, employees, and
              affiliates from any claims, liabilities, damages, losses, or
              expenses (including legal fees) arising out of:
            </p>
            <ul>
              <li>Your violation of these Terms & Conditions.</li>
              <li>Your use of our services.</li>
              <li>
                Your violation of any third‑party rights or applicable laws.
              </li>
              <li>Fraudulent or unauthorized transactions conducted by you.</li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>13. Termination</h2>
            <p>
              We may suspend or terminate your access to our services at any
              time, without prior notice, for any reason, including if you
              violate these Terms or fail to maintain compliance with KYC
              requirements. Upon termination, your right to use the services
              will cease immediately. Outstanding commission settlements will be
              processed as per policy.
            </p>
          </div>

          <div className="privacy-card">
            <h2>14. Governing Law & Dispute Resolution</h2>
            <p>
              These Terms shall be governed by and construed in accordance with
              the laws of India. Any dispute arising out of or relating to these
              Terms shall be subject to the exclusive jurisdiction of the courts
              in <strong>Kolkata, West Bengal</strong>.
            </p>
            <p>
              Before initiating any legal proceedings, you agree to first
              attempt to resolve the dispute by contacting our support team at{" "}
              <strong>support@formaxmoney.in</strong>. If the dispute cannot be
              resolved within 30 days, either party may pursue legal remedies as
              per applicable law.
            </p>
          </div>

          <div className="privacy-card">
            <h2>15. Force Majeure</h2>
            <p>
              We shall not be liable for any delay or failure to perform our
              obligations under these Terms if such delay or failure results
              from events beyond our reasonable control, including but not
              limited to acts of God, natural disasters, pandemics, war,
              terrorism, riots, strikes, government actions, bank strikes, power
              outages, or internet failures.
            </p>
          </div>

          <div className="privacy-card">
            <h2>16. Waiver & Severability</h2>
            <p>
              Our failure to enforce any right or provision of these Terms shall
              not be deemed a waiver of such right or provision. If any
              provision of these Terms is found to be invalid or unenforceable
              by a court of competent jurisdiction, the remaining provisions
              shall remain in full force and effect.
            </p>
          </div>

          <div className="privacy-card">
            <h2>17. Entire Agreement</h2>
            <p>
              These Terms, together with our{" "}
              <a href="/privacy-policy">Privacy Policy</a>, constitute the
              entire agreement between you and FORMAX IT SOLUTIONS PRIVATE
              LIMITED regarding your use of our services, superseding any prior
              agreements.
            </p>
          </div>

          <div className="privacy-card">
            <h2>18. Grievance Officer</h2>
            <p>
              In compliance with the Information Technology Act, 2000, and RBI
              guidelines, the Grievance Officer for user complaints is:
            </p>
            <p>
              <strong>Name:</strong> Mr. Ezazul Haque (Compliance Officer)
              <br />
              <strong>Email:</strong> admin@formaxmoney.in
              <br />
              <strong>Phone:</strong> +91 7890090500
              <br />
              <strong>Address:</strong> N0060, Mochpole, Near Junior School,
              Nabapally, Barasat, Kolkata - 700126, West Bengal, India
            </p>
            <p>
              Complaints shall be acknowledged within 24 hours and resolved
              within one month from the date of receipt.
            </p>
          </div>

          <div className="privacy-card">
            <h2>19. Changes to Terms</h2>
            <p>
              We reserve the right to update or modify these Terms at any time
              without prior notice. Your continued use of our services after any
              changes constitutes acceptance of the modified Terms.
            </p>
          </div>

          <div className="privacy-card">
            <h2>20. Contact Us</h2>
            <p>
              If you have any questions about these Terms & Conditions, please
              contact us at:
            </p>
            <p>
              <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong>
              <br />
              N0060, Mochpole, Near Junior School, Nabapally, Barasat,
              <br />
              Kolkata - 700126, West Bengal, India
              <br />
              Email: support@formaxmoney.in
              <br />
              Phone: +91 7890090500
              <br />
              Website: www.formaxmoney.in
            </p>
          </div>
        </div>
      </div>

      <Footer />

      <style>{`
        .page-hero {
          background: linear-gradient(135deg, #0A2540 0%, #1A3A5F 100%);
          padding: 60px 0 70px;
          text-align: center;
        }
        .page-hero h1 {
          font-size: 2.8rem;
          margin-bottom: 16px;
          color: white;
          font-weight: 700;
        }
        .page-hero p {
          color: rgba(255,255,255,0.85);
          max-width: 700px;
          margin: 0 auto;
          font-size: 1.1rem;
        }
        
        .privacy-content {
          margin: 60px 0;
        }
        
        .privacy-card {
          background: white;
          border-radius: 28px;
          padding: 32px;
          margin-bottom: 30px;
          box-shadow: 0 10px 25px -5px rgba(0,0,0,0.05);
          border: 1px solid #eef2ff;
          transition: all 0.3s ease;
        }
        
        .privacy-card:hover {
          border-color: rgba(212, 175, 55, 0.3);
          box-shadow: 0 15px 30px -10px rgba(0,0,0,0.1);
        }
        
        .privacy-card h2 {
          font-size: 1.6rem;
          margin-bottom: 16px;
          color: #0A2540;
          font-weight: 700;
        }
        
        .privacy-card p {
          margin-bottom: 16px;
          line-height: 1.6;
          color: #475569;
        }
        
        .privacy-card ul {
          margin-left: 24px;
          margin-bottom: 8px;
        }
        
        .privacy-card li {
          margin-bottom: 10px;
          line-height: 1.5;
          color: #475569;
        }
        
        .privacy-card a {
          color: #D4AF37;
          text-decoration: none;
        }
        
        .privacy-card a:hover {
          text-decoration: underline;
        }
        
        @media (max-width: 768px) {
          .page-hero {
            padding: 40px 0 50px;
          }
          .page-hero h1 { 
            font-size: 2rem; 
          }
          .page-hero p {
            font-size: 1rem;
            padding: 0 20px;
          }
          .privacy-card h2 { 
            font-size: 1.3rem; 
          }
          .privacy-card { 
            padding: 24px; 
          }
        }
        
        @media (max-width: 576px) {
          .privacy-card ul {
            margin-left: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default TermsAndConditions;
